export default class BaseModel {
    id: number | any;
    active: boolean | any;
    url: string | any;
    created_at: string | any;
    modified_at: string | any;
}
